import React from 'react';
import { useTheme } from 'theming';
import useStyles from './styles';
import clsx from 'clsx';
import { Paper } from '../Paper';
import { Typography } from '../Typography';
import { format, getMinutes } from 'date-fns';
import { Icon } from '..';
const weekdays = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
const DateDisplayer = ({ date, label, variant = 'success', customClassName = '', inlineStyles = {}, regular = true, showWeekday = false, showDay = true, hourTextColor = '#fff', labelTextColor = '#fff', weekdayColor = '#fff', icon, iconColor = 'success' }) => {
    const theme = useTheme();
    const classes = useStyles({ theme });
    const containerStyle = clsx({
        [classes.container]: true,
        [customClassName]: Boolean(customClassName),
    });
    date = new Date(date);
    const day = format(date, 'dd/MM/yy');
    const minutes = getMinutes(date);
    const formatedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const hour = format(date, `HH:`).replace(':', 'h');
    const timeString = hour + (minutes !== 0 ? formatedMinutes : '');
    const formattedLabel = label ? label.toLowerCase() : '';
    const formattedWeekday = weekdays[date.getDay()].substring(0, 3).toLowerCase();
    return (React.createElement(Paper, { customClassName: containerStyle, variant: variant, inlineStyles: inlineStyles, regular: regular },
        showDay && (React.createElement(Typography, { variant: 'content2', weight: "light", inheritColor: true, inlineStyles: { color: weekdayColor } }, showWeekday ? formattedWeekday : day)),
        React.createElement(Typography, { variant: 'header3', weight: 'bolder', inheritColor: true, inlineStyles: { color: hourTextColor } }, timeString),
        !!label &&
            React.createElement(React.Fragment, null,
                React.createElement("span", { className: classes.grow }),
                icon && (React.createElement(Icon, { name: icon, height: 20, width: 20, color: iconColor, inlineStyles: {
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: 2
                    } })),
                React.createElement(Typography, { variant: 'content3', weight: 'bold', inlineStyles: { color: labelTextColor, textAlign: 'center' } }, formattedLabel))));
};
export { DateDisplayer };
//# sourceMappingURL=DateDisplayer.js.map